module.exports = __webpack_public_path__ + "images/emoji/clock230.191241b900e7df20c62d.png";